import React, { useEffect } from "react";
import styles from "./ReviewAlert.module.scss";
import { formatDate } from "./Review";
import api from "../../libs/api";
import Tracking from "@magic-engineering/magic-tracking";
import { setAssistant } from "../../redux/assistants";
import { Alert } from "@magic-engineering/components";

function ReviewAlert({ assistant, showReviewForm }) {
  const { name = "", email, review = { dismiss: false } } = assistant;

  useEffect(() => {
    async function fetchReviewStatus() {
      try {
        const { data } = await api.get(`/assistants/feedbacks/status/${email}`);
        setAssistant({
          ...assistant,
          review: {
            ...review,
            ...data,
            fetched: true,
          },
        });
      } catch (e) {
        console.error(e);
      } finally {
      }
    }

    if (email && !review.fetched) {
      fetchReviewStatus();
    }
  }, [email, review, assistant]);

  const dismissAlert = () => {
    Tracking.assistantReviewDismissed();
    setAssistant({
      ...assistant,
      review: {
        ...review,
        dismiss: true,
      },
    });
  };

  const isVisible = !(review.dismiss || !review.bill_id || review.rating);

  if (isVisible) Tracking.assistantReviewViewed();

  return (
    <div>
      <div
        className={`col-12 p-0 ${styles.ReviewAlert} ${isVisible && styles.ReviewAlertVisible}`}
        data-testid="ReviewAlert"
      >
        <Alert
          title={`${name.split(" ")[0]} is awaiting your feedback for ${formatDate(
            review.start_date,
            review.end_date
          )}`}
          text="Leaving an honest review can help your assistant improve!"
          buttonLabel="Leave a Review"
          onClick={() => {
            showReviewForm({ assistant, review });
          }}
          onDismiss={dismissAlert}
          className={`${styles.AlertPrimary}`}
        />
      </div>
    </div>
  );
}

export default ReviewAlert;
